import { StateCreator } from "zustand";
import { AnalyticsSliceType } from "./storeAnalytics.types";

const createAnalyticsSlice: StateCreator<AnalyticsSliceType> = (set) => ({
  analyticsIncidentList: null,
  analyticsIncidentTrend: null,
  analyticsRepeatIncident: null,
  analyticsIncidentRate: null,
  analyticsStatusReport: null,
  analyticsInjuryReport: null,
  reportType: "",
  trendSelectedFacility: null,
  startDate: "",
  endDate: "",
  grouping: "Monthly",
  fallFacility: null,
  woundFacility: null,
  behaviorFacility: null,
  caregiverAuditFacility: null,
  caregiverAuditIncidentTypes: [],
  caregiverAuditCaregiverIds: [],
  fallAnalysisIncidents: null,
  woundAnalysisIncidents: null,
  behaviorAnalysisIncidents: null,
  incidentSelectedFacilities: null,
  globalSelectedFacility: null,
  globalAnaylyticsFacility: null,
  globalAnalyticsSelectedIncidentType: null,
  globalAnalyticsSelectedResidentStatus: [],
  globalAnalyticsSelectedWoundType: [],
  globalAnalyticsSelectedBehaviorIncidentType: [],
  globalAnalyticsSelectedInjuryType: [],
  globalAnalyticsSelectedBehaviorIncidentSubType: [],
  setFallFacility: (fallFacility: any) =>
    set(() => {
      return { fallFacility };
    }),
  setWoundFacility: (woundFacility: any) =>
    set(() => {
      return { woundFacility };
    }),
  setFallAnalysisIncidents: (fallAnalysisIncidents: any) =>
    set(() => {
      return { fallAnalysisIncidents };
    }),
  setWoundAnalysisIncidents: (woundAnalysisIncidents: any) =>
    set(() => {
      return { woundAnalysisIncidents };
    }),
  setAnalyticsIncidentList: (analyticsIncidentList: any) =>
    set(() => {
      return { analyticsIncidentList };
    }),
  setAnalyticsIncidentTrend: (analyticsIncidentTrend: any) =>
    set(() => {
      return { analyticsIncidentTrend };
    }),
  setAnalyticsIncidentRate: (analyticsIncidentRate: any) =>
    set(() => {
      return { analyticsIncidentRate };
    }),
  setAnalyticsStatusReport: (analyticsStatusReport: any) =>
    set(() => {
      return { analyticsStatusReport };
    }),
  setAnalyticsRepeatIncident: (analyticsRepeatIncident: any) =>
    set(() => {
      return { analyticsRepeatIncident };
    }),
  setReportType: (reportType: string) =>
    set(() => {
      return { reportType };
    }),
  setTrendSelectedFacility: (trendSelectedFacility: any) =>
    set(() => {
      return { trendSelectedFacility };
    }),
  setStartDate: (startDate: string) =>
    set(() => {
      return { startDate };
    }),
  setEndDate: (endDate: string) =>
    set(() => {
      return { endDate };
    }),
  setGrouping: (grouping: string) =>
    set(() => {
      return { grouping };
    }),
  setIncidentSelectedFacilities: (incidentSelectedFacilities: any) =>
    set(() => {
      return { incidentSelectedFacilities };
    }),
  setGlobalSelectedFacility: (globalSelectedFacility: any) =>
    set(() => {
      return { globalSelectedFacility };
    }),
  setGlobalAnalyticsSelectedIncidentType: (
    globalAnalyticsSelectedIncidentType: any
  ) =>
    set(() => {
      return { globalAnalyticsSelectedIncidentType };
    }),
  setGlobalAnalyticsSelectedResidentStatus: (
    globalAnalyticsSelectedResidentStatus: string[]
  ) =>
    set(() => {
      return { globalAnalyticsSelectedResidentStatus };
    }),
  setGlobalAnaylyticsFacility: (globalAnaylyticsFacility: any) =>
    set(() => {
      return { globalAnaylyticsFacility };
    }),
  setGlobalAnalyticsSelectedWoundType: (
    globalAnalyticsSelectedWoundType: string[]
  ) =>
    set(() => {
      return { globalAnalyticsSelectedWoundType };
    }),
  setAnalyticsInjuryReport: (analyticsInjuryReport: any) =>
    set(() => {
      return { analyticsInjuryReport };
    }),
  setGlobalAnalyticsSelectedInjuryType: (
    globalAnalyticsSelectedInjuryType: string[]
  ) =>
    set(() => {
      return { globalAnalyticsSelectedInjuryType };
    }),
  setBehaviorFacility: (behaviorFacility: any) =>
    set(() => {
      return { behaviorFacility };
    }),
  setCaregiverAuditFacility: (
    caregiverAuditFacility: AnalyticsSliceType["caregiverAuditFacility"]
  ) =>
    set(() => {
      return { caregiverAuditFacility };
    }),
  setCaregiverAuditIncidentTypes: (caregiverAuditIncidentTypes: string[]) =>
    set(() => {
      return { caregiverAuditIncidentTypes };
    }),
  setCaregiverAuditCaregiverIds: (caregiverAuditCaregiverIds: string[]) =>
    set(() => {
      return { caregiverAuditCaregiverIds };
    }),
  setBehaviorAnalysisIncidents: (behaviorAnalysisIncidents: any) =>
    set(() => {
      return { behaviorAnalysisIncidents };
    }),
  setGlobalAnalyticsSelectedBehaviorIncidentType: (
    globalAnalyticsSelectedBehaviorIncidentType: any
  ) =>
    set(() => {
      return { globalAnalyticsSelectedBehaviorIncidentType };
    }),
  setGlobalAnalyticsSelectedBehaviorIncidentSubType: (
    globalAnalyticsSelectedBehaviorIncidentSubType: any
  ) =>
    set(() => {
      return { globalAnalyticsSelectedBehaviorIncidentSubType };
    }),
});

export default createAnalyticsSlice;
